import store from '@/store'
import { CLEAR, INIT, SET_LOADING_STATUS, SET_STATUS_MESSAGE, SPLICE, SET_TOTAL_COUNT } from './mutation-types'

const state = {
  categories: [],
  totalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllCategories: (state) => {
    return state.categories
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async init ({ commit }, { newCategories, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newCategories, totalCount: isFullArraySize ? totalCount : newCategories.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async next ({ commit }, { newCategories, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE, { newCategories, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  clear ({ commit }) {
    commit(CLEAR)
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT] (state, { newCategories, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newCategories))
    state.categories = new Array(totalCount)
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'categoryContacts',
        params: { categoryId: obj.id },
        query: { categoryName: obj.name } }
      return obj
    })
    state.categories.splice(0, objs.length, ...mappedObjs)
  },
  [SPLICE] (state, { newCategories, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newCategories))
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'categoryContacts',
        params: { categoryId: obj.id },
        query: { categoryName: obj.name } }
      return obj
    })
    state.categories.splice(startIndex, objs.length, ...mappedObjs)
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [CLEAR] (state) {
    state.categories = []
    state.status = {
      loading: false,
      message: 'Loading Categories. Please wait...'
    }
    state.totalCount = 0
  }
}

export const category = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
